import { SuperAdminConstants } from '../../../_constants';

const initialState = { delAssignMetricLoading: true, data: '', error: false };

export function delAssignMetricListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_DELETE_EXISTING_METRIC:
            return {
                delAssignMetricListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_DELETE_EXISTING_METRIC:
            return {
                delAssignMetricListLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.DELETE_EXISTING_METRIC_ERROR:
            return {
                delAssignMetricListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignMetric/delNewCompetencyAssignMetric.reducer.js